export enum CirclesGraphViews {
  AllCircles = 'AllCircles',
  SimpleCircles = 'SimpleCircles',
  FlatCircle = 'FlatCircle',
  Members = 'Members',
}
